export const suppliersEndpoints = {
  validateBankDetails: { method: 'post', path: '/validate-bank-details' },
  validateAba: { method: 'post', path: '/validate-aba' },
  validateBankAccount: { method: 'post', path: '/validate-bank-account' },
  listSuppliersPaginated: { method: 'post', path: '/paginated' },
  createSupplier: { method: 'post', path: '/create' },
  getSupplierOverview: { method: 'get', path: '/{id}/overview' },
  getSupplierOverviewFields: { method: 'get', path: '/{id}/overview/fields' },
  getSupplierOverviewFieldOptions: { method: 'get', path: '/{id}/overview/fields/{fieldId}/options' },
  createSupplierOverviewFieldOption: { method: 'post', path: '/overview/fields/{fieldId}/options' },
  setSupplierOverviewFieldValue: { method: 'post', path: '/{id}/overview/fields/{fieldId}/value' },
  getSupplierForConditions: { method: 'get', path: '/{id}/for-conditions' },
  updateSupplierCategories: { method: 'post', path: '/{id}/categories' },
  updateSupplier: { method: 'post', path: '/{id}/update' },
  archiveSupplier: { method: 'post', path: '/{id}/archive' },
  getSupplierMergeableFields: { method: 'post', path: '/mergeable-fields' },
  mergeSuppliers: { method: 'post', path: '/merge-organisation-suppliers' },
  unmergeSupplierProfile: { method: 'post', path: '/{id}/profiles/{subsidiaryId}/unmerge' },
  getSupplierOverviewConfig: { method: 'get', path: '/overview-config' },
  getSupplierProfileOverviewFieldValues: { method: 'get', path: '/{id}/profiles/fields' },
  listGlobalAndOrgSupplierBrands: { method: 'get', path: '/global-and-org-supplier-brands' },
  uploadSuppliers: { method: 'post', path: '/bulk-upload' },
  getSupplierSubmissions: { method: 'get', path: '/{id}/submissions' },
  getSupplierSubmission: { method: 'get', path: '/submission/{id}' },
  uploadHistoricSubmissions: { method: 'post', path: '/historic-submissions' },
  getGlobalSupplierMatches: { method: 'get', path: '/global-matches' },
  linkOrgSuppliersToGlobal: { method: 'post', path: '/link-org-suppliers-to-global' },
  // engagements
  createEngagement: { method: 'post', path: '/engagements' },
  getEngagement: { method: 'get', path: '/engagements/{id}' },
  getEngagementsForSupplier: { method: 'get', path: '/{id}/engagements' },
  // bank accounts
  getSupplierBankAccounts: { method: 'get', path: '/{id}/bank-accounts' },
  getSupplierProfileBankAccounts: { method: 'get', path: '/{id}/supplier-profiles/{profileId}/bank-accounts' },
  // online resources
  listSupplierOnlineResources: { method: 'get', path: '/{id}/online-resources' },
  upsertSupplierOnlineResource: { method: 'post', path: '/{id}/online-resources' },
} as const
